import PaymentDetails from "./PaymentDetails";

const PaymentDetailWrapper = () => {
  return <PaymentDetails />;
};
export default PaymentDetailWrapper;
